import React from 'react';
import QrScanner from './QrScanner';
import Packet from './Packet';
import QR from './QR';
import FakeQrScanner from './FakeQrScanner';

import { saveAs } from 'file-saver';
import { Redirect } from 'react-router-dom';

class Receive extends React.Component {
  constructor(props) {
    super(props);
    this.handleScan = this.handleScan.bind(this);
    this.handleEOF = this.handleEOF.bind(this);
    this.state = {
      showCamera: false,
      redirect: false,
      nextPacket: null,
      metadata: {},
      fileHash: 0,
      sequenceNumber: 0,
      dataBuffer: [],
    };
    this.toggleCamera = this.toggleCamera.bind(this);
  }

  toggleCamera() {
    this.setState((state) => ({ showCamera: !state.showCamera }));
  }

  handleScan(buffer) {
    const packet = Packet.decodeArrayBuffer(buffer);
    if (!packet) {
      console.log('received empty packet', buffer);
      return;
    }
    console.log('received', packet.toString());
    if (
      packet.packetType !== Packet.packetTypes.INITIAL_PACKET &&
      this.state.file &&
      packet.fileHash !== this.state.fileHash
    ) {
      console.log(
        `Received packet for different fileHash, expected[${this.state.fileHash}] got[${packet.fileHash}]`
      );
      return;
    }
    if (packet.sequenceNumber !== this.state.sequenceNumber) {
      console.log(
        `Received packet for different sequenceNumber, expected[${this.state.sequenceNumber}] got[${packet.sequenceNumber}]`
      );
      return;
    }
    switch (packet.packetType) {
      case Packet.packetTypes.INITIAL_PACKET:
        const fileHash = packet.fileHash;
        this.setState({
          metadata: packet.extractFileMetadata(),
          nextPacket: Packet.encodeAckPacket(fileHash, 0),
          sequenceNumber: 1,
          fileHash: fileHash,
          dataBuffer: [],
        });
        break;
      case Packet.packetTypes.DATA_PACKET:
        this.setState((state) => ({
          nextPacket: Packet.encodeAckPacket(
            state.fileHash,
            state.sequenceNumber
          ),
          sequenceNumber: state.sequenceNumber + 1,
          dataBuffer: state.dataBuffer.concat(packet.data),
        }));
        break;
      case Packet.packetTypes.EOF_PACKET:
        this.setState((state) => ({
          nextPacket: Packet.encodeAckPacket(
            state.fileHash,
            state.sequenceNumber
          ),
          sequenceNumber: state.sequenceNumber + 1,
          dataBuffer: state.dataBuffer.concat(packet.data),
        }));
        window.setTimeout(() => this.handleEOF(), 5000);
        break;
      case Packet.packetTypes.ACK_PACKET:
        console.log('Ack packet received in Receive mode', packet.toString());
        break;
      default:
        console.log('Unknown packet type received', packet.toString());
    }
  }

  handleEOF() {
    const byteArray = new Uint8Array(
      this.state.dataBuffer.reduce((sum, buffer) => sum + buffer.byteLength, 0)
    );
    let cursor = 0;
    this.state.dataBuffer.forEach((buffer) => {
      byteArray.set(new Uint8Array(buffer), cursor);
      cursor += buffer.byteLength;
    });
    // console.log('file received', byteArray, new TextDecoder().decode(byteArray));
    saveAs(
      new Blob([byteArray.buffer], {
        type: this.state.metadata.type
          ? this.state.metadata.type.trim()
          : 'text/plain',
      }),
      this.state.metadata.name ? this.state.metadata.name.trim() : 'nfft.txt'
    );
    this.setState({ redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to='/' />;
    }
    return (
      <div>
        <p>Receive page</p>
        {/*<FakeQrScanner handleScan={this.handleScan}/>*/}
        {this.state.nextPacket ? (
          <QR
            data={this.state.nextPacket.toBinaryString()}
            width={Math.floor(
              Math.min(window.innerWidth, window.innerHeight) * 0.9
            )}
          />
        ) : (
          <p>Awaiting sender</p>
        )}
        <button className={'btn btn-primary'} onClick={this.toggleCamera}>
          Toggle Camera
        </button>
        <QrScanner
          handleScan={this.handleScan}
          hidden={!this.state.showCamera}
        />
      </div>
    );
  }
}

export default Receive;
